'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["categoryV2", "page"];
import memoize from 'hs-lodash/memoize';
import { CategoryV2Slug } from 'marketplace-ui-apps-core/common/constants/urlSlugs/CategoryV2Slug';
const getCategoryV2FromSlug = memoize(slug => {
  return Object.keys(CategoryV2Slug).find(key => CategoryV2Slug[key] === slug);
});
export const getParsedPathParams = _ref => {
  let {
      categoryV2,
      page
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return Object.assign({}, rest, {
    categoryV2: getCategoryV2FromSlug(categoryV2),
    page: page ? parseInt(page, 10) : undefined
  });
};
export const getIsAllReviews = match => match.path.endsWith('/:slug/reviews') && match.isExact;